var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00011 2L10.9701 3.43701L13.4085 3.43237L14.1576 5.75289L16.133 7.18239L15.3751 9.5L16.133 11.8176L14.1576 13.2471L13.4085 15.5676L10.9701 15.563L9.00011 17L7.03012 15.563L4.59172 15.5676L3.84262 13.2471L1.86719 11.8176L2.62511 9.5L1.86719 7.18239L3.84262 5.75289L4.59172 3.43237L7.03012 3.43701L9.00011 2Z",
    fill: "#952623",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 9.5L8.25 11.375L12 7.625",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyIcon2);
export default __webpack_public_path__ + "static/media/verify-icon-2.d955b58ad5d6322175782f2b59128f0c.svg";
export { ForwardRef as ReactComponent };